import { WriteMeteringObservationItemDto } from '../dtos/write-metering-observation-item.dto';

export class WriteMeteringObservationsRequest {
  records!: WriteMeteringObservationItemDto[];
}
